import { useCallback, useState } from 'react';

/** Pause handlers for a toast card that owns its own drain animation. */
export function useToastDrainPaused(): [
  boolean,
  {
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    onFocus: () => void;
    onBlur: () => void;
  },
] {
  const [paused, setPaused] = useState(false);
  const onMouseEnter = useCallback(() => setPaused(true), []);
  const onMouseLeave = useCallback(() => setPaused(false), []);
  const onFocus = useCallback(() => setPaused(true), []);
  const onBlur = useCallback(() => setPaused(false), []);
  return [paused, { onMouseEnter, onMouseLeave, onFocus, onBlur }];
}

/** Mirrors Sonner's hover/focus dismiss pause on a mounted `[data-sonner-toast]` node. */
export function bindSonnerToastDrainPause(
  toastEl: HTMLElement,
  setPaused: (paused: boolean) => void,
): () => void {
  const onPause = () => setPaused(true);
  const onResume = () => setPaused(false);
  toastEl.addEventListener('mouseenter', onPause);
  toastEl.addEventListener('mouseleave', onResume);
  toastEl.addEventListener('focusin', onPause);
  toastEl.addEventListener('focusout', onResume);
  return () => {
    toastEl.removeEventListener('mouseenter', onPause);
    toastEl.removeEventListener('mouseleave', onResume);
    toastEl.removeEventListener('focusin', onPause);
    toastEl.removeEventListener('focusout', onResume);
  };
}
